import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateScheduleAlerts = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 500,
	height: 500,
	viewBox: "0 0 500 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11025_42018)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M247.948 463.853C354.988 463.853 441.761 377.081 441.761 270.041C441.761 163.002 354.988 76.2289 247.948 76.2289C140.909 76.2289 54.1362 163.002 54.1362 270.041C54.1362 377.081 140.909 463.853 247.948 463.853Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M440.461 269.779C445.961 269.779 450.42 265.32 450.42 259.82C450.42 254.32 445.961 249.861 440.461 249.861C434.961 249.861 430.502 254.32 430.502 259.82C430.502 265.32 434.961 269.779 440.461 269.779Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.234 53.1742C181.845 53.1742 185.583 49.4363 185.583 44.8254C185.583 40.2145 181.845 36.4766 177.234 36.4766C172.623 36.4766 168.885 40.2145 168.885 44.8254C168.885 49.4363 172.623 53.1742 177.234 53.1742Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.3488 336.402C44.9598 336.402 48.6977 332.664 48.6977 328.054C48.6977 323.443 44.9598 319.705 40.3488 319.705C35.7379 319.705 32 323.443 32 328.054C32 332.664 35.7379 336.402 40.3488 336.402Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M453.091 149.866C461.325 149.866 468 143.191 468 134.957C468 126.723 461.325 120.048 453.091 120.048C444.857 120.048 438.183 126.723 438.183 134.957C438.183 143.191 444.857 149.866 453.091 149.866Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M375.614 169.008H122.418C113.69 169.008 106.615 176.084 106.615 184.811V376.68C106.615 385.407 113.69 392.483 122.418 392.483H375.614C384.342 392.483 391.417 385.407 391.417 376.68V184.811C391.417 176.084 384.342 169.008 375.614 169.008Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M375.626 173.779C381.709 173.779 386.647 178.729 386.647 184.8V376.68C386.647 382.762 381.697 387.7 375.626 387.7H122.406C116.324 387.7 111.386 382.75 111.386 376.68V184.811C111.386 178.729 116.335 173.791 122.406 173.791H375.614M375.626 164.238H122.406C111.052 164.238 101.844 173.445 101.844 184.8V376.68C101.844 388.034 111.052 397.242 122.406 397.242H375.614C386.969 397.242 396.176 388.034 396.176 376.68V184.811C396.176 173.457 386.969 164.249 375.614 164.249L375.626 164.238Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M416.142 370.776H293.414C291.637 370.776 290.074 371.933 289.55 373.638L287.486 380.425C287.021 381.939 285.626 382.977 284.051 382.977H211.858C210.271 382.977 208.876 381.939 208.423 380.425L206.359 373.638C205.847 371.933 204.272 370.776 202.495 370.776H79.7672C74.6028 370.776 70.4165 374.962 70.4165 380.127V393.187C70.4165 398.351 74.6028 402.537 79.7672 402.537H416.13C421.294 402.537 425.48 398.351 425.48 393.187V380.127C425.48 374.962 421.294 370.776 416.13 370.776H416.142Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M330.113 119.559H165.808C152.634 119.559 141.954 130.239 141.954 143.413V301.54C141.954 314.714 152.634 325.394 165.808 325.394H330.113C343.287 325.394 353.967 314.714 353.967 301.54V143.413C353.967 130.239 343.287 119.559 330.113 119.559Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M165.808 119.559H330.113C343.28 119.559 353.967 130.246 353.967 143.413V153.289H141.954V143.413C141.954 130.246 152.641 119.559 165.808 119.559Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M301.226 112.51V127.443",
				stroke: "#9EC5FF",
				strokeWidth: 14.3123,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M194.683 112.51V127.443",
				stroke: "#9EC5FF",
				strokeWidth: 14.3123,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M191.797 225.816H177.341C174.417 225.816 172.046 228.187 172.046 231.112V245.567C172.046 248.492 174.417 250.863 177.341 250.863H191.797C194.721 250.863 197.092 248.492 197.092 245.567V231.112C197.092 228.187 194.721 225.816 191.797 225.816Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M234.054 225.816H219.598C216.674 225.816 214.303 228.187 214.303 231.112V245.567C214.303 248.492 216.674 250.863 219.598 250.863H234.054C236.978 250.863 239.349 248.492 239.349 245.567V231.112C239.349 228.187 236.978 225.816 234.054 225.816Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M276.311 225.816H261.855C258.93 225.816 256.56 228.187 256.56 231.112V245.567C256.56 248.492 258.93 250.863 261.855 250.863H276.311C279.235 250.863 281.606 248.492 281.606 245.567V231.112C281.606 228.187 279.235 225.816 276.311 225.816Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M191.797 272.033H177.341C174.417 272.033 172.046 274.404 172.046 277.329V291.784C172.046 294.709 174.417 297.079 177.341 297.079H191.797C194.721 297.079 197.092 294.709 197.092 291.784V277.329C197.092 274.404 194.721 272.033 191.797 272.033Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M234.054 272.033H219.598C216.674 272.033 214.303 274.404 214.303 277.329V291.784C214.303 294.709 216.674 297.079 219.598 297.079H234.054C236.978 297.079 239.349 294.709 239.349 291.784V277.329C239.349 274.404 236.978 272.033 234.054 272.033Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M276.311 272.033H261.855C258.93 272.033 256.56 274.404 256.56 277.329V291.784C256.56 294.709 258.93 297.079 261.855 297.079H276.311C279.235 297.079 281.606 294.709 281.606 291.784V277.329C281.606 274.404 279.235 272.033 276.311 272.033Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M234.054 179.921H219.598C216.674 179.921 214.303 182.292 214.303 185.217V199.672C214.303 202.597 216.674 204.968 219.598 204.968H234.054C236.978 204.968 239.349 202.597 239.349 199.672V185.217C239.349 182.292 236.978 179.921 234.054 179.921Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M276.311 179.921H261.855C258.93 179.921 256.56 182.292 256.56 185.217V199.672C256.56 202.597 258.93 204.968 261.855 204.968H276.311C279.235 204.968 281.606 202.597 281.606 199.672V185.217C281.606 182.292 279.235 179.921 276.311 179.921Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M318.556 179.921H304.1C301.176 179.921 298.805 182.292 298.805 185.217V199.672C298.805 202.597 301.176 204.968 304.1 204.968H318.556C321.48 204.968 323.851 202.597 323.851 199.672V185.217C323.851 182.292 321.48 179.921 318.556 179.921Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M324.972 292.034C350.952 292.034 372.012 270.974 372.012 244.995C372.012 219.015 350.952 197.955 324.972 197.955C298.993 197.955 277.933 219.015 277.933 244.995C277.933 270.974 298.993 292.034 324.972 292.034Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M300.594 282.183L275.917 282.552C272.816 282.6 270.789 279.308 272.22 276.553L283.658 254.679L300.594 282.171V282.183Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M323.47 225.566H326.475C335.981 225.566 343.686 233.283 343.686 242.776V253.272H306.247V242.776C306.247 233.271 313.964 225.566 323.458 225.566H323.47Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M343.292 250.72H306.664C304.8 250.72 303.289 252.228 303.289 254.089C303.289 255.95 304.8 257.458 306.664 257.458H343.292C345.156 257.458 346.667 255.95 346.667 254.089C346.667 252.228 345.156 250.72 343.292 250.72Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M324.973 269.349C329.744 269.349 333.727 265.95 334.622 261.454H315.312C316.218 265.962 320.19 269.349 324.961 269.349H324.973Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M324.639 221.582C326.368 221.582 327.763 222.989 327.763 224.707V227.367H321.514V224.707C321.514 222.977 322.921 221.582 324.639 221.582Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M310.112 242.848C309.837 242.573 309.694 242.192 309.73 241.786C309.969 239.496 310.708 237.337 311.913 235.358C312.938 233.676 314.25 232.233 315.813 231.076C316.397 230.646 317.208 230.766 317.649 231.338C318.079 231.923 317.96 232.746 317.387 233.175C316.087 234.141 315.002 235.334 314.155 236.729C313.153 238.375 312.545 240.164 312.342 242.06C312.27 242.776 311.626 243.301 310.899 243.229C310.589 243.194 310.314 243.062 310.112 242.848Z",
				fill: "#FFC700"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11025_42018",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 436,
			height: 436,
			fill: "white",
			transform: "translate(32 32)"
		})
	}) })]
});
export default SvgEmptyStateScheduleAlerts;
